/* eslint-disable no-unused-vars */
import { createRouter, createWebHistory } from "vue-router";
import pathLoader from "../plugins/loader";
const routes = [
  {
    path: "/",
    name: "Home",
    component: pathLoader("home"),
  },

  /* Components Root */
  {
    path: "/",
    name: "Header",
    component: pathLoader("./components/header/index.vue"),
  },
  {
    path: "/",
    name: "Footer",
    component: pathLoader("./components/footer/index.vue"),
  },
  {
    path: "/signup",
    name: "Signup",
    component: pathLoader("signup"),
  },
  {
    path: "/success",
    name: "Success",
    component: pathLoader("success"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
